import tokml from 'tokml';
import http from '@/utils/http';

import i18n from '@/main';

export default {
    async getSafras() {
        return http.get({
            url: '/safra',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeSafras')
        });
    },

    async getCamadas() {
        return http.get({
            url: '/camadas?filtro=',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoCamadasDoUsuario')
        });
    },

    async getCamadasVinculadas(idEmpresa) {
        return http.get({
            url: `/camadas/vinculadas/${idEmpresa}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoCamadasDoUsuario')
        });
    },

    async getSafrasVigentes() {
        return http.get({
            url: '/safra/vigentes',
            lockScreen: false,
            lockMessage: 'Buscando dados de safras vigentes'
        });
    },

    async getCulturas() {
        return http.get({
            url: `/culturas`,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.aguardeBuscandoDadosDeCulturas'
            )
        });
    },
    async getCulturasMonitoramento() {
        return http.get({
            url: `/culturas-monitoramento`,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.aguardeBuscandoDadosDeCulturas'
            )
        });
    },
    findAlertas(filtro) {
        return http.post({
            url: '/alertas',
            data: filtro,
            lockScreen: false
        });
    },
    getQuantitativos() {
        return http.get({
            url: '/quantitativos',
            lockScreen: true
        });
    },

    getDadosCAR(codigosCAR) {
        return http.post({
            url: `/cars`,
            data: codigosCAR,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCarsSobrepostos')
        });
    },

    getDadosCARSemGeometria(codigo) {
        return http.get({
            url: `/car/${codigo}`,
            lockScreen: true,
            lockMessage: 'Buscando CARs'
        });
    },

    baixarKMLdeGeometria(geoJson) {
        const kml = tokml(geoJson);
        const convertedKML =
            'application/xml;charset=utf-8,' + encodeURIComponent(kml);

        const elDownload = document.createElement('a');
        elDownload.setAttribute('href', 'data:' + convertedKML);
        elDownload.setAttribute('download', 'poligono.kml');

        document.body.appendChild(elDownload);
        elDownload.click();
        document.body.removeChild(elDownload);
    },

    async baixarArquivo(url) {
        const fileLink = document.createElement('a');
        try {
            const params = { url, responseType: 'blob' };
            const response = await http.get(params);
            const fileURL = window.URL.createObjectURL(
                new Blob([response.data])
            );
            const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
            const contentDisposition = response.headers['content-disposition'];
            const filename = filenameRegex.exec(contentDisposition)?.[1];

            if (!filename) {
                throw new Error(i18n.t('laudos.erroObterArquivo'));
            }

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
            return response;
        } catch (error) {
            throw error;
        } finally {
            fileLink.remove();
        }
    },

    buscarTotalizadores() {
        return http.get({
            url: '/totalizador',
            lockScreen: false
        });
    },
    enviarPingWebsocket() {
        return http.get({
            url: '/ws/ping',
            lockScreen: false
        });
    }
};
